import React, { ReactElement } from "react";
import CorporateEmployeeList from "../../components/Corporate/Employee";
import Layout from "../../components/layout";

const CorporateEmployeepage = (): ReactElement => {
  return (
    <Layout>
      <CorporateEmployeeList />
    </Layout>
  );
};

export default CorporateEmployeepage;
